// The assignment values stored in whatsappThreads intentionally match the
// labels shown in the two owner dropdowns. Keep the identity mapping explicit:
// several login names (for example comercial.ap3) do not resemble the label,
// while first-name matching would confuse the two Andreas.
const ASSIGNEE_BY_USERNAME: Record<string, string> = {
  "andre.sandoval": "Andre Sandoval",
  "diego.catter": "Diego Catter",
  "alamo.madrid": "Alamo Cusihuaman",
  "francesco.larosa": "Francesco La Rosa",
  "sandy.hernandez": "Sandy Hernandez",
  "comercial.ap1": "Yeniffer Quevedo",
  "comercial.ap2": "Jonathan",
  "jefferson.madrid": "Jefferson Merino",
  "jasmin.madrid": "Jasmin Suarez",
  "comercial.ap.tl": "Suyin Rodríguez",
  "comercial.ap3": "Fernando Rondón",
  "comercial.ap4": "Kimberlin Rincon",
  "comercial.ap5": "Carina Hernández",
  "comercial.ap6": "Andrea Sánchez",
  "comercial.ap7": "Cristian Vicent",
  "comercial.ap8": "Alba Pérez",
  "comercial.ap9": "Linda Montoya",
  "comercial.ap10": "Alexandra Gomez",
  "gabriela.lume": "Gabriela Lume",
  "joaquin.uribe": "Joaquin Uribe",
  "andrea.leyva": "Andrea Leyva",
  "genesis.paredes": "Génesis Paredes",
  "andrea.cornejo": "Andrea Cornejo",
  // Faltaba, y sin entrada aqui whatsappAssigneeForEmail devuelve "" y
  // canMarkWhatsappThreadRead da false SIEMPRE: no podia quitar el punto rojo
  // de ninguno de sus chats, y el globo de la campana solo le subia. Tenia 15
  // hilos de operaciones asignados el 07/09/2026.
  "alejandro.martinez": "Alejandro Martinez",
};

// Quien puede llevar hilos del area de operaciones. Vive aqui, junto al mapa
// de permisos, porque las dos listas TIENEN que ir a la vez: estaba solo en
// WhatsAppApp.tsx y por eso se pudo anadir a alguien a los desplegables sin
// darle permiso para marcar leido. El test de este fichero lo comprueba.
export const OPERACIONES_PEOPLE = [
  "Andre Sandoval", "Diego Catter", "Sandy Hernandez", "Andrea Cornejo", "Alejandro Martinez",
];

// Solo para tests: el valor que se guarda como dueno del hilo, por usuario.
export const ASSIGNEE_VALUES = Object.values(ASSIGNEE_BY_USERNAME);

type WhatsappReadOwner = {
  area?: "comercial" | "operaciones";
  assignedComercial?: string;
  assignedOperaciones?: string;
};

const LEGACY_OWNER_NAMES: Record<string, string> = {
  andre: "andre sandoval",
  diego: "diego catter",
  alamo: "alamo cusihuaman",
  francesco: "francesco la rosa",
  sandy: "sandy hernandez",
  yeniffer: "yeniffer quevedo",
};

const normalizeOwner = (value?: string | null): string => {
  const normalized = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
  return LEGACY_OWNER_NAMES[normalized] || normalized;
};

export const whatsappAssigneeForEmail = (email?: string | null): string => {
  const username = String(email || "").trim().toLowerCase().split("@")[0];
  return ASSIGNEE_BY_USERNAME[username] || "";
};

export const canMarkWhatsappThreadRead = (
  thread: WhatsappReadOwner | null | undefined,
  email?: string | null
): boolean => {
  if (!thread) return false;
  const activeOwner = thread.area === "operaciones"
    ? thread.assignedOperaciones
    : thread.assignedComercial;
  const userOwner = whatsappAssigneeForEmail(email);
  return !!userOwner && normalizeOwner(activeOwner) === normalizeOwner(userOwner);
};

export const canReturnToComercial = (groups?: string[] | null): boolean =>
  Array.isArray(groups) && (groups.includes("admin") || groups.includes("operaciones"));
